import ReactGA from 'react-ga4';

const { REACT_APP_TRACKING_GOOGLE, REACT_APP_TYPE } = process.env;
const useTagManager = (REACT_APP_TRACKING_GOOGLE || '').startsWith('GTM-');
const testMode = (REACT_APP_TYPE !== 'production');

if (!useTagManager) {
  ReactGA.initialize(REACT_APP_TRACKING_GOOGLE, { testMode: testMode });
}

export function trackGoogleEvent(name, parameters = {}) {
  if (useTagManager) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ...parameters, event: name });
  } else {
    ReactGA.event(name, parameters);
  }
}

export function trackGooglePageView() {
  if (useTagManager) {
    trackGoogleEvent('page_view', { page_path: window.location.pathname });
  } else if (!testMode) {
    ReactGA.send({ hitType: 'pageview', page: window.location.pathname });
  }
}
